import { BlockStack, Link, Text } from '@shopify/polaris';
import './Turn14PartnerCallout.css';

export default function Turn14PartnerCallout() {
    return (
        <aside className="pf-turn14-partner" aria-label="Data Here-to-There">
            <BlockStack gap="200">
                <Text as="h4" variant="headingSm">For your Turn14 store operations</Text>
                <Text as="p" variant="bodySm">
                    Turn 14 Distribution by Data Here-to-There supports product imports, inventory and pricing updates, and order and shipping automation.
                </Text>
                <Link url="https://apps.shopify.com/turn-14-distribution-api" external>View app on Shopify</Link>
            </BlockStack>
        </aside>
    );
}
